export enum IndicatorUpdateExpectedDirections {
  Up = 1,
  Down = 2,
}
